import { DefaultsApi, useAPIQuery } from "melco-shared-logic";

export const useGetRoles = () => {
  return useAPIQuery(
    DefaultsApi,
    ["getroles"],
    async (api) => {
      //const api = new UserRolesApi(baseApiConfig({ token }));

      // if (selectedProductValue) {

      const response = await api.defaultsGetRoles({});

      return response;
      // }
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
